import { Component, input } from '@angular/core';
import type { OnyxColor } from '../interfaces';

@Component({
  selector: 'onyx-dot',
  imports: [],
  templateUrl: './onyx-dot.component.html',
  styleUrl: './onyx-dot.component.scss',
})
export class OnyxDotComponent {
  public readonly color = input.required<OnyxColor>();
  public readonly size = input(8);
  public readonly pulse = input(false);
}
